import React from 'react';
import './AboutMe.css';

export default function AboutMe() {
  const qualities = [
    "Driven",
    "Enthusiastic",
    "Versatile",
    "Empathetic",
    "Lifelong-learner",
    "Optimistic",
    "Persistent",
    "Experimental",
    "Resilient"
  ];

  return (
    <div className="about-me-container">
      {/* Left Section for Developer Qualities (Smaller Design) */}
      <div className="developer-qualities">
        {qualities.map((quality, index) => (
          <div key={index} className="quality-line">
            <span className="first-letter">{quality[0]}</span>
            <span className="remaining-letters">{quality.slice(1)}</span>
          </div>
        ))}
      </div>

      {/* Right Section for "WHO AM I" Content */}
      <div className="about-me-details-container">
        <div className="about-me-details">
          <h2>WHO AM I ?</h2>
          <p className="full-name">I’m Fenofifaliana RAFANOMEZANTSOA</p>
          <p>
            <span className="text-bg">A developer passionate about</span>
            <span className="dev-container">[web, software]</span>
            <span className="text-bg">
              development. Continuously eager to grow my skill set, I'm also deeply curious about the evolving digital landscape and how businesses innovate and adapt in a fast-paced world.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
